const footerData = {
    menu: [
        {
            title: "Company", data: [
                {
                    name: "About Us", href: "https://shelfperks.in/about"
                },
                {
                    name: "Become a Partner", href: "https://shelfperks.in/partners"
                },
                {
                    name: "Careers", href: "https://2497inc.com/careers"
                },
            ]
        },
        {
            title: "Explore", data: [
                {
                    name: "Types of Business", href: "https://shelfperks.in/business-types"
                },
                {
                    name: "Store Operating System", href: "https://shelfperks.in/store-operating-system"
                },
                {
                    name: "Enterprise Solutions", href: "https://shelfperks.in/enterprise"
                },
                {
                    name: "Savings Calculator", href: "https://shelfperks.in/savings-calculator"
                },
            ]
        },
        // {
        //     title: "Resources", data: [
        //         {
        //             name: "Blogs", href: "https://shelfperks.in/resources#Blogs"
        //         },
        //         {
        //             name: "Guides", href: "https://shelfperks.in/resources#Blogs"
        //         },
        //         {
        //             name: "Store Owner Hacks", href: "https://shelfperks.in/resources#storeownerhack"
        //         },
        //     ]
        // },
        {
            title: "Assist", data: [
                {
                    name: "Get Help", href: "https://support.shelfperks.in/"
                },
                {
                    name: "Change Plan", href: "https://grow.shelfperks.in/#/authenticate"
                },
                {
                    name: "FAQs", href: "https://shelfperks.in/faq"
                },
            ]
        },
    ]
}


export default footerData;